<template>
  <div>
    <b-card header="Default" class="p-2" :no-body="allowCollapse">
      <template slot="header">
        <span
          ><b>{{ title || $lang.files }}</b></span
        >
        <div class="float-right">
          <b-button
            @click="!filesLoading && loadFiles()"
            class="btn ml-2 btn-lightgray btn-secondary"
          >
            <mdicon
              name="refresh"
              :class="{ 'spinner center': filesLoading }"
              size="20"
            />
          </b-button>
          <b-button
            v-if="
              mode === 'showUpload' && showAdd && permissions.includes('admin')
            "
            @click="toggleUploadArea"
            class="btn ml-2 btn-lightgray btn-secondary"
          >
            <mdicon :name="isCollapse ? 'minus' : 'plus'" size="20" />
          </b-button>
          <!-- <b-button
            v-if="allowCollapse && files.length"
            @click="isCollapseFiles = !isCollapseFiles"
            :class="
              files.length > 0 ? 'btn-success ml-2' : 'btn-lightgray ml-2'
            "
          >
            <span v-if="isCollapseFiles" key="fa fa-angle-up"
              ><i class="fa fa-angle-up"></i
            ></span>
            <span v-else key="fa fa-angle-down"
              ><i class="fa fa-angle-down"></i
            ></span>
          </b-button> -->
        </div>
      </template>
      <LoadingSpinner :loading="isLoading" />

      <b-row v-if="!isLoading" class="mx-0">
        <b-col xs="12" md="12" class="mb-3 px-0" v-if="topAlert">
          <b-alert show variant="info" class="mb-0">
            <i class="fas fa-info-circle fa-lg mr-1" />
            <b v-text="topAlert" />
          </b-alert>
        </b-col>
        <b-col cols="12" md="12" class="px-0" v-if="mode == `showUpload`">
          <b-collapse v-model="isCollapse" class="mt-2">
            <div v-if="showForm">
              <b-alert variant="info" show dismissible>
                <strong>
                  {{ $lang.info_upload_files }}
                </strong>
              </b-alert>
              <b-form-group
                :label="$lang.attachment_type"
                label-for="attachment_type"
                :label-cols="this.$config.form.labelCol"
              >
                <requiredComponent
                  slot="label"
                  :label="$lang.attachment_type"
                  :rules="$v.attachment_type_selected.$params"
                />
                <selectFind
                  :options="attachmentTypeComboOptions"
                  v-model="attachment_type_selected"
                  label="text"
                  id="value"
                  :loading="attachmentTypeLoading"
                  :isValid="
                    $v.attachment_type_selected.$dirty &&
                    !attachment_type_selected
                      ? !$v.attachment_type_selected.$error
                      : null
                  "
                />
                <b-form-invalid-feedback
                  :style="{
                    display: $v.attachment_type_selected.$error
                      ? 'block'
                      : 'none',
                  }"
                  id="attachment_type_selected_feedback"
                >
                  {{ $lang.error_required | replace($lang.attachment_type) }}
                </b-form-invalid-feedback>
              </b-form-group>
              <b-form-group
                :label="$lang.caption"
                label-for="caption"
                :label-cols="$config.form.labelCol"
              >
                <requiredComponent
                  slot="label"
                  :label="$lang.caption"
                  :rules="$v.caption.$params"
                />
                <b-form-input
                  id="caption"
                  type="text"
                  autocomplete="off"
                  v-model="$v.caption.$model"
                  :state="$v.caption.$dirty ? !$v.caption.$error : null"
                >
                </b-form-input>
                <b-form-invalid-feedback id="caption-feedback"
                  >{{ $lang.error_required | replace($lang.caption) }}
                </b-form-invalid-feedback>
              </b-form-group>
            </div>
            <FileDrag
              v-if="
                checkCountUploadFiles &&
                (!showForm || this.attachment_type_selected)
              "
              :maxUploadFile="maxUploadFile"
              ref="fileDrag"
              @uploadFile="attachmentTemp"
              :acceptFormats="allowAcceptFormats"
              :multiple="multiple"
              :crop="crop"
              :aspectRatio="
                parentAspectRatio !== false ? parentAspectRatio : aspectRatio
              "
              :initialAspectRatio="
                parentInitialAspectRatio !== false
                  ? parentInitialAspectRatio
                  : initialAspectRatio
              "
            />
          </b-collapse>
        </b-col>
        <b-col xs="12" md="12" class="px-0">
          <filelistPorgress
            :allowFileSize="allowFileSize"
            v-if="mode == `showUpload` && fileUpload.length > 0"
            :isBtnFinal="isBtnFinal"
            :fileUpload="fileUpload"
            :keyServies="keyServies"
            :keyValue="keyValue"
            :attachmentTypeId="
              pathOr(
                parentAttachmentTypeId,
                ['value'],
                attachment_type_selected
              )
            "
            @removeFile="removeFileProgress"
            @removeFiles="removeFiles"
            @finalSave="finalSave"
            @getResponseCode="getResponseCode"
          />
        </b-col>
        <b-col xs="12" md="12" class="px-0" v-if="files.length">
          <b-collapse v-if="!isCollapse" v-model="isCollapseFiles" class="mt-2">
            <b-overlay
              :class="
                mode == `showUpload` && isCollapse ? `overlay-wrap-main` : ``
              "
              :show="filesLoading"
              rounded="sm"
            >
              <FileList
                :showFilePreview="showFilePreview"
                :showCheckbox="showCheckbox"
                v-if="mode == `showUpload`"
                :files="files"
                :classFile="classFile"
                :keyService="keyServies"
                :keyValue="keyValue"
                :hasEditTypeAttachment="hasEditTypeAttachment"
                @removeFile="removeFile"
                @checkbox="checkbox"
                @saveCrop="saveCrop"
                @loadFiles="loadFiles"
                :permissions="permissions"
                :attachment_type_name="attachment_type_name"
              />
            </b-overlay>
          </b-collapse>
        </b-col>
        <b-col xs="12" md="12" class="text-center px-0" v-else>
          <b-alert class="my-3" :show="!isCollapse">
            <h5>{{ $lang.noFileExist }}</h5>
          </b-alert>
        </b-col>
        <b-col v-if="!filesLoading" xs="12" md="12" class="text-right mt-3">
          <PaginationSearch
            :allowPaginate="true"
            :total="totalRows"
            :total_pages="total_pages"
            :perPage="perPage"
            v-model="page"
            @input="paging"
          />
          <!-- <div
            class="btnShowMore"
            v-if="files.length > 8 && !btnMore && total_pages != page"
            @click="showMore"
          >
            <i class="fa fa-angle-double-down" aria-hidden="true"></i>
            {{ $lang.more }}
            <i class="fa fa-angle-double-down" aria-hidden="true"></i>
          </div> -->
        </b-col>
        <confirm
          :title="modalTitle"
          :description="message"
          v-model="confirmModal"
          :ok-title="$lang.yes"
          :cancel-title="$lang.no"
          @ok="okConfim"
          @cancel="cancelConfim"
        ></confirm>
      </b-row>
    </b-card>
  </div>
</template>
<script>
import { generateApiUrl } from "@/shared/utils";
import { pathOr, includes } from "ramda";
/**
 * @group contentPriview
 * این کامپوننت برای نمایش فایل  تعریف شده است
 */

import FileList from "./../fileManager/fileList";
import FileDrag from "./../fileManager/fileDrag";
import confirm from "./confirm";
import filelistPorgress from "./../fileManager/filelistPorgress";
import { required, requiredIf } from "vuelidate/lib/validators";
import LoadingSpinner from "@/components/base/LoadingSpinner";
import PaginationSearch from "@/components/base/paganationSearch";

export default {
  name: "upload-file",
  components: {
    FileList, // کامپوننت فایل‌ها
    FileDrag, // کامپوننت درک فایل
    filelistPorgress, // کامپوننت فایل‌های آپلودی
    confirm, // کامپوننت کانفرم
    LoadingSpinner,
    PaginationSearch,
  },
  inject: [
    "attachmentTempRepository",
    "attachmentFilesRepository",
    "attachmentTempFinalRepository",
    "attachmentRepository",
  ],
  props: {
    title: {
      type: String,
      default: "",
    },
    keyServies: {
      type: String,
      default: "",
    },
    keyValue: {
      type: [String, Number],
      default: "",
    },
    propAttachmentType: {
      type: Boolean,
      default: false,
    },
    allowCollapse: {
      type: Boolean,
      default: false,
    },
    isCollapseFiles: {
      type: Boolean,
      default: true,
    },
    maxUploadFile: {
      type: Number,
      default: 1048576,
    },
    file_types: {
      type: Array,
      default: () => [],
    },
    showAdd: {
      type: Boolean,
      default: true,
    },
    parentPermissions: {
      type: Array,
      default: () => [],
    },
    parent_attachment_type_options: {
      type: Array,
      default: () => [],
    },
    attachment_type_name: {
      type: String,
      default: "attachment_type_person",
    },
    parentAttachmentTypeId: {
      type: [Number, String],
      default: null,
    },
    outParams: {
      type: Object,
      default: () => {},
    },
    parentUploadFile: {
      type: Boolean,
      default: false,
    },
    outButton: {
      type: Array,
      default: () => [],
    },
    allowFileSize: {
      type: Number,
      default: null,
    },
    topAlert: {
      type: String,
      default: "",
    },
    acceptFormats: {
      // فرمت‌های مرد قبول
      type: Array,
      default: () => [
        {
          caption: "عکس",
          value: "1MB",
        },
        {
          caption: "مجموعه آفیس",
          value: "20MB",
        },
        {
          caption: "ویدیو/صوت",
          value: "50MB",
        },
        {
          caption: "بقیه فایل‌ها",
          value: "10MB",
        },
      ],
    },
    customPermission: {
      // این پرمیشن هم بالاترین اولویت را نسبت به سایر ئرمیشن‌ها دارد.
      type: Array,
      default: () => [],
    },
    attachmentRoute: {
      /* guidance: This prop will be replaced with the word "attachment" in the URL of the attachment service (just in get service) */
      type: String,
      default: "attachment",
    },
    crop: {
      type: Boolean,
      default: true,
    },
    showForm: {
      type: Boolean,
      default: true,
    },
    showFilePreview: {
      type: Boolean,
      default: true,
    },
    showCheckbox: {
      type: Boolean,
      default: false,
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    classFile: {
      type: String,
      default: "col-12 col-sm-6 col-md-4 col-xl-3",
    },
    parentAspectRatio: {
      type: [Number, Boolean],
      default: null,
    },
    parentInitialAspectRatio: {
      type: [Number, Boolean],
      default: null,
    },
    maxCountUploadFiles: {
      type: Number,
      default: null,
    },
    hasEditTypeAttachment: {
      type: Boolean,
      default: false,
    },
    perPage: {
      type: Number,
      default: 20,
    },
  },
  validations: {
    attachment_type_selected: {
      required: requiredIf((vm) => vm.showForm),
    },
    caption: {},
  },
  data() {
    return {
      isBtnFinal: false,
      permissions: [],
      isCollapse: false, // برای باز وبستن کولیس
      classFilter: "", // کلاس‌های استفاده در زمان نمایش فیلتر
      classData: "col-12", // کلاس‌های استفاده در زمان نمایش فیلتر
      mode: "showUpload", // هندل کردن حالت‌های مختلف نمایش
      confirmModal: false, // بازکردن مدال کانفرم
      modalTitle: "", // عنوان مدال
      message: "", // نمایش متن حذف فایل
      loadScroll: false, // لودینگ اسکرول
      inputSearch: "", // مقدار فیلتر
      filter: false, // نمایش یا عدم نمایش
      page: 1, // شماره پیج
      filterUrl: "", // ادر به همراه فیلتر
      total_pages: 0, // تعداد کل پیج خا
      totalRows: 0, // تعداد کل پیج خا
      folders: [], // ارایه پوشه‌ها
      responseCode: [], // کد‌های ارسال شده به اتچمنت فایل
      fileUpload: [], // فایل‌های آپلود شده
      filterheaders: [], // عنوان فیلتر
      filterItems: {}, // آیتم‌های فیلتر
      files: [], // فایل‌های موجود در پوشه
      filesLoading: false, // مدال فایل لیست
      removingItemCode: null, // ایتمی که در حال حذف می باشد
      navItem: [
        {
          // منو
          caption: "مدیریت فایل",
          href: "#",
          icon: "fa fa-folder",
        },
      ],
      attachment_type_selected: null,
      defaultButtons: [
        {
          id: "1",
          name: "video", // ویدیو
          iconFont: "fa-video-camera fa-lg px-2",
          text: this.$lang.design_exercise_tooltip,
          AllowPermissions: ["admin", "edit"],
          click: this.designExercise,
        },
        {
          id: "2",
          name: "download", // دانلود
          iconFont: "fa fa-download px-2  fa-lg  ",
          text: this.$lang.search.edit_tooltip,
          AllowPermissions: ["admin", "edit"],
          click: this.modify,
        },
        {
          id: "3",
          name: "delete", //حذف
          text: this.$lang.search.remove_tooltip,
          iconFont: "fas fa-times fa-lg px-2 ",
          AllowPermissions: ["admin"],
          click: this.removing,
        },
        {
          id: "4",
          name: "view", //نمایش
          text: this.$lang.show,
          iconFont: "fa fa-eye fa-lg  px-2 ",
          AllowPermissions: ["admin", "edit", "view"],
          click: this.modify,
        },
      ],
      btnMore: false,
      allowFileTypes: [],
      isLoading: false,
      caption: null,
      aspectRatio: 1 / 1,
      initialAspectRatio: 1 / 1,
      attachmentTypeComboOptions: [],
      attachmentTypeLoading: false,
    };
  },
  computed: {
    allowAcceptFormats() {
      return this.allowFileTypes.length
        ? this.allowFileTypes
        : this.acceptFormats;
    },
    checkCountUploadFiles() {
      if (this.maxCountUploadFiles) {
        return this.maxCountUploadFiles > this.files.length;
      }
      return true;
    },
  },
  watch: {
    attachment_type_selected(item) {
      const text = pathOr("", ["text"], item);
      const value = pathOr(null, ["value"], item);
      this.caption = text;
      /* guidance: check if type upload was profile image set 3/4 aspect ratio for cropping */
      const con = value === 10;
      this.aspectRatio = con ? 1 / 1 : null;
      if (this.parentAspectRatio !== false) {
        this.aspectRatio = this.parentAspectRatio;
      }
      this.initialAspectRatio = con ? 1 / 1 : null;
      if (this.parentInitialAspectRatio !== false) {
        this.initialAspectRatio = this.parentInitialAspectRatio;
      }
    },
    files(items) {
      this.$emit("getFiles", items);
    },
  },
  created() {
    this.loadFiles();
    this.getAttachmentTypeCombo();
  },
  methods: {
    pathOr,
    includes,
    generateApiUrl,
    loadpageOne() {
      this.page = 1;
      this.files = [];
      this.loadFiles();
      this.btnMore = false;
    },
    async saveCrop(item) {
      try {
        this.filesLoading = true;
        const attachmentCode = pathOr(null, ["code"], item);
        const url = generateApiUrl(
          ["resources", "attachment_crop"],
          [attachmentCode]
        );
        const attachment_type_id = pathOr(
          this.parentAttachmentTypeId,
          ["attachment_type_id"],
          item
        );

        const formData = new FormData();
        formData.append("file", item.img);
        formData.append(
          "attachment_type_name",
          this.attachmentTypeName(attachment_type_id)
        );

        if (this.allowFileSize) {
          formData.append("allowFileSize", this.allowFileSize);
        }
        const response = await this.$httpService.post(url, formData, {
          "Content-Type": "multipart/form-data",
        });
        this.$notify.success(response.data.message);
        this.loadpageOne();
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.filesLoading = false;
      }
    },
    /* async saveCrop(item) {
      try {
        this.filesLoading = true;
        let file = item.img;
        let formData = new FormData();
        formData.append("image", file);
        if (this.allowFileSize) {
          formData.append("allowFileSize", this.allowFileSize);
        }

        const response = await this.attachmentTempRepository.create(
          formData,
          {
            "Content-Type": "multipart/form-data",
          },
          true
        );
        const data = pathOr(null, ["data", "data"], response);
        this.responseCode.push({
          code: pathOr(null, ["code"], data),
          name: pathOr(null, ["name"], data),
          type: pathOr(null, ["type"], data),
          attachment_type_id: pathOr(null, ["attachment_type_id"], item),
        });
      } catch (error) {
        this.$generateError(error);
        return;
      } finally {
        this.filesLoading = false;
      }

      let payload = {
        data: [],
      };
      const attachment_type_id = pathOr(
        this.parentAttachmentTypeId,
        ["attachment_type_id"],
        item
      );
      for (const item of this.responseCode) {
        payload.data.push({
          code: item.code,
          unlimited: false,
          attachment_type_id,
          attachment_type_name: this.attachmentTypeName(attachment_type_id),
          caption: this.caption,
        });
      }
      try {
        this.filesLoading = true;

        let file_name = this.keyServies;
        let file_id = this.keyValue;
        const response = await this.attachmentTempFinalRepository.create(
          payload,
          file_name,
          file_id
        );

        this.$notify.success(response.data.message);
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.fileUpload = [];
        this.responseCode = [];
        // this.$refs.fileDrag.clearValue();
        this.loadpageOne();
        this.filesLoading = false;
      }
    }, */
    showMore() {
      if (this.total_pages > this.page) {
        this.page = this.page + 1;
        this.loadFiles();
      } else {
        this.btnMore = true;
      }
    },
    paging(page) {
      this.page = page;
      this.loadFiles();
    },
    /**
     * @vuese
     * 	برای ارسال عکس دیفالت
     *  @arg  ابجکت که سلکت بودن یا نبودن بهراه ایدی
     */
    async checkbox(file) {
      this.filesLoading = true;
      try {
        let payload = {
          is_default: file.checked ? 1 : 0,
        };
        let file_name = this.keyServies;
        let file_id = this.keyValue;
        const response = await this.attachmentRepository.partial_edit(
          file.id,
          payload,
          file_name,
          file_id
        );
        this.files.map((x) => {
          if (x.id != file.id) {
            x.default = false;
          }
        });
        this.$notify.success(response.data.message);
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.filesLoading = false;
      }
    },
    /**
     * @vuese
     * پاک کردن پیغام تایید پاک کردن
     *  @arg  بدون پارامتر
     */
    clearModalConfirm() {
      this.modalTitle = "";
    },
    /**
     * @vuese
     * قبول کردن فایل حذف شود
     *  @arg  بدون پارامتر
     */
    async okConfim() {
      this.filesLoading = true;
      try {
        let file_name = this.keyServies;
        let file_id = this.keyValue;
        const response = await this.attachmentTempFinalRepository.delete(
          file_name,
          file_id,
          this.removingItemCode
        );
        this.confirmModal = false;
        this.$notify.success(response.data.message);
        this.files = this.files.filter((x) => x.code !== this.removingItemCode);
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.filesLoading = false;
      }
      this.clearModalConfirm();
    },
    /**
     * @vuese
     * لغو کردن فایل حذف شود
     *  @arg  بدون پارامتر
     */
    cancelConfim() {
      this.confirmModal = false;
      this.clearModalConfirm();
    },
    /**
     * @vuese
     *  ریمو فایل
     *  @arg ایتم فایل
     */
    async removeFile(item) {
      this.removingItemCode = pathOr(null, ["code"], item);
      this.message = this.$lang.are_you_sure_to_remove_item.replace(
        "{item}",
        item.name
      );
      this.modalTitle = this.$lang.remove_item;
      this.confirmModal = true;
    },
    getResponseCode(responseCode) {
      this.responseCode = responseCode;
    },
    /**
     * @vuese
     *     ریمو فایل  آپلود شده
     *  @arg ایتم فایل
     */
    removeFileProgress(item) {
      let indexFile = this.fileUpload.indexOf(item);
      let response = this.responseCode.find((x) => x.name == item.name);
      let indexResponse = this.responseCode.indexOf(response);
      this.fileUpload.splice(indexFile, 1);
      this.responseCode.splice(indexResponse, 1);
      this.$refs.fileDrag.clearValue();
    },
    /**
     * @vuese
     *     ریمو فایل‌های آپلود شده
     *  @arg بدون پارامتر
     */
    removeFiles() {
      this.fileUpload = [];
      this.$refs.fileDrag.clearValue();
    },
    /**
     * @vuese
     *    کال کردن سرویس به صورت هم زمان برای ذخیره
     *  @arg ابجکت پوشه انتخابی
     */
    async attachmentTemp(files) {
      this.fileUpload = [...this.fileUpload, ...files];
    },
    attachmentTypeName(item) {
      switch (item) {
        case 21:
          return "attachment_type_interview";
        case 22:
          return "attachment_type_ticket";
        case 23:
          return "attachment_type_person";
        case 25:
          return "attachment_type_ready_report";
        case 24:
          return "attachment_type_research";
        default:
          return this.attachment_type_name;
      }
    },
    /**
     * @vuese
     *    ذخیره نهایی فایل‌های آپلود شده
     *  @arg بدون پارامتر
     */
    async finalSave(responseCode) {
      this.$v.$touch();
      if (this.$v.$anyError) return;

      this.isBtnFinal = true;
      this.responseCode = responseCode;
      if (this.fileUpload.length == this.responseCode.length) {
        let payload = {
          data: [],
        };
        const attachment_type_selected = pathOr(
          null,
          ["value"],
          this.attachment_type_selected
        );
        for (const item of this.responseCode) {
          const attachment_type_id = pathOr(
            this.parentAttachmentTypeId,
            ["attachment_type_id"],
            item
          );
          payload.data.push({
            code: item.code,
            unlimited: false,
            attachment_type_name: this.attachmentTypeName(
              attachment_type_selected || attachment_type_id
            ),
            attachment_type_id: pathOr(
              this.parentAttachmentTypeId,
              ["value"],
              this.attachment_type_selected
            ),
            caption: this.caption,
          });
        }

        try {
          let file_name = this.keyServies;
          let file_id = this.keyValue;

          const response = await this.attachmentTempFinalRepository.create(
            payload,
            file_name,
            file_id
          );
          this.$notify.success(response.data.message);
          this.isCollapse = false;
          this.caption = null;
        } catch (err) {
          this.$generateError(err);
        } finally {
          this.$v.$reset();
          this.attachment_type_selected = null;
          this.caption = null;
          this.fileUpload = [];
          this.responseCode = [];
          this.$refs.fileDrag.clearValue();
          this.loadpageOne();
        }
      } else {
        this.$notify.error(this.$lang.allFilesNotUploaded);
      }
      // }
      this.isBtnFinal = false;
    },
    /**
     * @vuese
     *   گرفتن داده‌های فایل در پوشه‌ها
     *  @arg بدون پارامتر
     */
    async getAllFiles() {
      this.isLoading = true;
      try {
        let params = {
          page: this.page,
          per_page: this.perPage,
          search_txt: this.inputSearch,
          ...this.outParams,
        };
        if (this.file_types) {
          let file_types = (params.file_types = []);
          this.file_types.map((x) => {
            file_types.push(x);
          });
        }

        /* guidance: delete attachment_type_id key of payload if base route is not array names */
        if (
          !includes(this.attachmentRoute, ["attachment", "attachment_company"])
        ) {
          delete params.attachment_type_id;
        }

        const response = await this.attachmentFilesRepository.list(
          this.keyServies,
          this.keyValue,
          params,
          this.attachmentRoute
        );

        if (!this.filterheaders.length > 0) {
          this.filterheaders = response.data.filters.map((x) => {
            return {
              key_filter_caption: x.key_filter_caption,
              key_filter_name: x.key_filter_name,
              key_service: x.key_service,
              open: x.open,
              type: x.type,
              loader: !x.open,
            };
          });

          let data = [...this.filterheaders];
          for (const item of data) {
            if (item.open) {
              this.getFilter(item);
            }
          }
        }
        let allFiles = [];
        if (response.data.data && "result" in response.data.data) {
          this.allowFileTypes = pathOr(
            [],
            ["data", "data", "result", "allow_file_types"],
            response
          );
          let data = response.data.data.result;
          // this.total_pages = response.data.data.total_pages;

          const responseData = pathOr(null, ["data", "data"], response);
          this.totalRows = pathOr(null, ["total"], responseData);
          this.total_pages = pathOr(null, ["total_pages"], responseData);

          if (response.data.permissions) {
            this.permissions = response.data.permissions;
          }
          if (this.parentPermissions.length && !response.data.permissions) {
            this.permissions = this.parentPermissions;
          }

          if (this.customPermission.length) {
            this.permissions = this.customPermission;
          }

          /* guidance: get this permissions of parent */
          this.$emit("getPermissions", this.permissions);

          allFiles = data.data.map((x) => {
            if (this.outButton.length) {
              x.buttons = this.outButton;
            } else {
              if (x.type.match("image")) {
                x.buttons = [
                  {
                    id: "1",
                    name: "edit",
                  },
                  {
                    id: "0",
                    name: "delete",
                  },
                  {
                    id: "2",
                    name: "crop",
                  },
                  {
                    id: "1",
                    name: "download", // دانلود
                    href: true,
                  },
                ];
              } else if (includes(x.ext, ["pdf", "xls", "xlsx"])) {
                x.buttons = [
                  {
                    id: "0",
                    name: "delete",
                  },
                  {
                    id: "1",
                    name: "download", // دانلود
                    href: true,
                  },
                ];
              } else {
                if (!this.parentUploadFile) {
                  x.buttons = [
                    {
                      id: "1",
                      name: "edit",
                    },
                    {
                      id: "0",
                      name: "delete",
                    },
                    {
                      id: "1",
                      name: "download", // دانلود
                      href: true,
                    },
                  ];
                } else {
                  x.buttons = this.outButton;
                }
              }
            }
            return x;
          });
        }
        this.$emit("getAllFiles", allFiles);
        return allFiles;
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.isLoading = false;
      }
    },
    async getLicense() {
      try {
        let params = {
          order_by: "id:asc",
          per_page: 150,
        };
        const response = await this.personLicenseRepository.list(
          this.code,
          params
        );
        if (response.data.data && response.data.data.length > 0) {
          this.licenses = response.data.data.map((x) => {
            if (response.data.data.length > 0)
              return {
                id: x.id,
                place_id: x.place_id,
                license_caption: x.name,
                licensee: {
                  value: x.place_id,
                  text: x.place_name,
                },
                license_number: x.license_no,
                Year_obtaining_license: x.license_year,
                credit_end_date: x.expire_date && x.expire_date.gregorian,
                regional_municipality: x && x.zone_number,
                location_selected: {
                  id: x.location_id,
                  caption: x.full_path,
                },
              };
          });
        }
        //
      } catch (err) {
        let errors = this.$generateError(err);
        errors.map((x) => this.$notify.error(x));
      }
    },
    /**
     * @vuese
     *   لود داده‌ها با اسکرول
     *  @arg بدون پارامتر
     */
    loadFiles() {
      this.filesLoading = true;
      return this.getAllFiles()
        .then((items) => {
          // this.files = [...this.files, ...items];
          this.files = [...items];

          return true;
        })
        .finally(() => (this.filesLoading = false));
    },
    /**
     * @vuese
     *  سطح دسترسی دکمه‌ها
     *  @arg بدون پارامتر
     */
    availableButtons() {
      return this.defaultButtons
        .filter((button) => {
          // compare button permission and user permissions
          let ok = Object.values(this.permissions).filter((x) =>
            button.AllowPermissions.includes(x)
          );
          // compare keys button has and defult button dosent have
          return ok.length > 0;
        })
        .map((but) => {
          let temp = Object.assign({}, but); // clone
          let permission = this.defaultButtons.find((x) => x.name == but.name);
          return {
            ...permission,
            ...temp,
          };
        });
    },
    toggleUploadArea() {
      if (!this.checkCountUploadFiles)
        return this.$notify.warning(
          `در این قسمت فقط امکان بارگزاری ${this.maxCountUploadFiles} فایل را دارید`
        );
      this.isCollapse = !this.isCollapse;
    },
    async getAttachmentTypeCombo() {
      if (this.propAttachmentType) {
        this.attachmentTypeComboOptions = this.parent_attachment_type_options;
        return;
      }
      try {
        this.attachmentTypeLoading = true;
        const url = generateApiUrl(["resources", "attachment_type_combo"]);
        const response = await this.$httpService.get(url);
        const data = pathOr([], ["data", "data"], response);
        this.attachmentTypeComboOptions = data.map((item) => {
          return {
            text: pathOr("", ["caption"], item),
            value: pathOr(null, ["id"], item),
          };
        });
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.attachmentTypeLoading = false;
      }
    },
  },
};
</script>
<style>
.dropDown-main {
  position: absolute;
  width: 100px;
  background: red;
  height: 100px;
}

.overlay-wrap-main {
  border-top: 1px solid #c8ced3;
  padding-top: 13px;
}

.position-badge {
  position: absolute !important;
  right: -6px;
  top: -7px !important;
}

.btnShowMore {
  font-size: 15px;
  font-weight: 500;
  background: #c2c9d8;
  color: black;
  width: 100px;
  text-align: center;
  border-radius: 5px;
  cursor: pointer;
  padding: 10px;
}
</style>
